import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import Axios from "axios";

const routePrefix = "/voortgangsrapportproject/";

const voortgangsrapportProjectApi = {
	getEmptyVoortgangsrapport(dossierId) {
		const serviceUrl = prependRoot(routePrefix + "empty/" + dossierId, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	get(vrProjectId) {
		const serviceUrl = prependRoot(routePrefix + vrProjectId, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	save(voortgangsrapportProject) {
		const serviceUrl = prependRoot(routePrefix, getApiRoot());
		return Axios.post(serviceUrl, voortgangsrapportProject, {
			headers: {
				'accept': 'application/json'
			}
		});
	}
};

export default voortgangsrapportProjectApi;
